import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, Plus, TrendingUp } from "lucide-react";

interface EmptyStateProps {
  onAddTransaction?: () => void;
  onViewTransactions?: () => void;
}

export function EmptyState({
  onAddTransaction,
  onViewTransactions,
}: EmptyStateProps) {
  return (
    <Card className="border-dashed border-2 border-muted-foreground/25 bg-muted/5">
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        {/* Icon */}
        <div className="relative mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <BarChart3 className="w-8 h-8 text-primary" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
            <TrendingUp className="w-4 h-4 text-secondary-foreground" />
          </div>
        </div>

        {/* Content */}
        <h3 className="text-lg font-semibold mb-2">No Financial Data Yet</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Start tracking your property's financial performance by adding
          transactions and monitoring income vs expenses.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
          {onAddTransaction && (
            <Button onClick={onAddTransaction} className="flex-1">
              <Plus className="w-4 h-4 mr-2" />
              Add Transaction
            </Button>
          )}
          {onViewTransactions && (
            <Button
              variant="outline"
              onClick={onViewTransactions}
              className="flex-1"
            >
              View Transactions
            </Button>
          )}
        </div>

        {/* Additional Info */}
        <div className="mt-6 text-xs text-muted-foreground">
          <p>Track rent payments, expenses, and other financial activities</p>
          <p>to get insights into your property's performance.</p>
        </div>
      </CardContent>
    </Card>
  );
}
